// Traveltek 이미지 자원을 요청할 때 사용하는 기본 호스트
export const BASE_IMAGE_URL = "https://img.wowcruise.kr";
